import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TestCard from "./TestCard";
import Tabs from "./Tabs";
import "./PaperListing.css";
import { ClipLoader } from "react-spinners";

export default function PyqListing() {
  //  SAFE SELECTORS
  // const pyqYearPaperList = useSelector(
  //   (state) => state.examSlice.pyqYearPaperList || []
  // );
  const selectedPyqYear = useSelector(
    (state) => state.examSlice.selectedPyqYear
  );
const aitsList = useSelector((state) => state.aitsTests.list);
const aitsTabs = useSelector((state) => state.aitsTests.tabs);
const isLoading=useSelector((state)=>state.aitsTests.loading);


  const tabs = ["All Tests", "Completed"];

  const [activeTab, setActiveTab] = useState("All Tests");

  useEffect(() => {
    setActiveTab("All Tests");
  }, [selectedPyqYear]);

  // const list =
  //   selectedPyqYear && pyqYearPaperList.length
  //     ? pyqYearPaperList
  //         .filter(
  //           (g) => String(g.target_year) === String(selectedPyqYear)
  //         )
  //         .flatMap((g) => g.data || [])
  //     : [];
const list =
  selectedPyqYear
    ? aitsList.filter(
        (test) => String(test.year) === String(selectedPyqYear)
      )
    : [];


  const filteredTests =
    activeTab === "All Tests"
      ? list
      : list.filter((test) => test.tab_name === activeTab);

      

  return (
    <div className="paperListingWrapper">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className="paperListingContent">
        {isLoading ? (
          <div className="paperListingContent__loader">
            <ClipLoader size={40} color="#C61C26" />
          </div>
        ) : filteredTests.length > 0 ? (
          filteredTests.map((test) => (
            <TestCard
              key={test.paper_id}
              test={test}
              isPyq
            />
          ))
        ) : (
          <p className="no_tests_text">No tests found.</p>
        )}
      </div>
    </div>
  );
}
